/* shto-scp-mnav: header menus (sections/shto-scp-mnav.liquid).
   Desktop: "Categories" is a link to the Collections page (click / Enter follows it). Hovering it opens the mega menu
   (short close delay); the chevron button next to it ([data-shto-mega-toggle]) opens / closes it on click, Enter/Space or
   Arrow Down; Esc closes it and returns focus to that button; it closes when focus or the pointer leaves it.
   Phones: the menu button opens the drawer (dialog): focus moves in and is trapped, the page behind can't scroll,
   Esc / the close button / the dim area close it and focus returns to the menu button. */
(() => {
  const root = document.querySelector('[data-shto-mnav]');
  if (!root || root.dataset.shtoReady) return;
  root.dataset.shtoReady = '1';
  const desk = window.matchMedia('(min-width: 1024px)');
  const focusables = (el) => [...el.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
    .filter((n) => n.offsetParent !== null || n.getClientRects().length);
  const eager = (el) => el.querySelectorAll('img[data-shto-lazy][loading="lazy"]').forEach((i) => { i.loading = 'eager'; });

  /* ---------- Desktop mega menu ---------- */
  const item = root.querySelector('[data-shto-mega-item]');
  const btn = root.querySelector('[data-shto-mega-toggle]');
  const mega = root.querySelector('[data-shto-mega]');
  let timer = 0;
  const megaOpen = () => btn && btn.getAttribute('aria-expanded') === 'true';
  function openMega() {
    clearTimeout(timer);
    if (!mega || megaOpen()) return;
    eager(mega);
    mega.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
  }
  function closeMega(focusBtn) {
    clearTimeout(timer);
    if (!mega || !megaOpen()) return;
    mega.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) btn.focus();
  }
  if (item && btn && mega) {
    const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
    item.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && hoverable.matches) openMega(); });
    item.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { clearTimeout(timer); timer = setTimeout(() => closeMega(false), 150); } });
    btn.addEventListener('click', () => { megaOpen() ? closeMega(false) : openMega(); });
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') { e.preventDefault(); openMega(); const f = focusables(mega)[0]; if (f) f.focus(); }
    });
    mega.addEventListener('keydown', (e) => {
      const list = focusables(mega);
      const i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i > -1) { e.preventDefault(); (list[i + 1] || list[0]).focus(); }
      if (e.key === 'ArrowUp' && i > -1) { e.preventDefault(); i === 0 ? btn.focus() : list[i - 1].focus(); }
      if (e.key === 'Home') { e.preventDefault(); list[0].focus(); }
      if (e.key === 'End') { e.preventDefault(); list[list.length - 1].focus(); }
    });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) closeMega(false); });
    document.addEventListener('click', (e) => { if (megaOpen() && !item.contains(e.target)) closeMega(false); });
    /* Warm the photos before the first open. */
    item.addEventListener('pointerenter', () => eager(mega), { once: true });
    btn.addEventListener('focus', () => eager(mega), { once: true });
  }

  /* ---------- Phone drawer ---------- */
  const toggle = root.querySelector('[data-shto-mnav-toggle]');
  const drawer = root.querySelector('[data-shto-mnav-drawer]');
  const panel = root.querySelector('[data-shto-mnav-panel]');
  const input = root.querySelector('[data-shto-mnav-input]');
  let lastFocus = null;
  const drawerOpen = () => drawer && !drawer.hidden;
  function openDrawer(focusEl) {
    if (!drawer || drawerOpen()) return;
    lastFocus = document.activeElement;
    eager(drawer);
    drawer.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('shto-mnav-lock');
    const f = focusEl || panel.querySelector('[data-shto-mnav-close]:not(.shto-scp-mnav__scrim)');
    requestAnimationFrame(() => f && f.focus({ preventScroll: true }));
  }
  function closeDrawer() {
    if (!drawerOpen()) return;
    drawer.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('shto-mnav-lock');
    const back = toggle.offsetParent !== null ? toggle : lastFocus;
    if (back && document.contains(back)) back.focus({ preventScroll: true });
  }
  if (toggle && drawer) {
    toggle.addEventListener('click', () => (drawerOpen() ? closeDrawer() : openDrawer()));
    toggle.addEventListener('pointerdown', () => eager(drawer), { once: true });
    drawer.addEventListener('click', (e) => { if (e.target.closest('[data-shto-mnav-close]')) closeDrawer(); });
    drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const list = focusables(panel);
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    desk.addEventListener('change', () => { if (desk.matches) closeDrawer(); else closeMega(false); });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawerOpen()) { e.preventDefault(); closeDrawer(); }
    else if (megaOpen()) { e.preventDefault(); closeMega(true); }
  });
  /* The cart drawer opening closes our menus. */
  document.addEventListener('cart-drawer:open', () => { closeDrawer(); closeMega(false); });

  /* ---------- Search: the store's predictive search toggles .search-open on the section; mirror it on the icon. */
  const sec = root.closest('.header-section');
  const sbtn = root.querySelector('[data-shto-mnav-search]');
  if (sec && sbtn) {
    const s = () => sbtn.setAttribute('aria-expanded', String(sec.classList.contains('search-open')));
    new MutationObserver(s).observe(sec, { attributes: true, attributeFilter: ['class'] });
    sbtn.addEventListener('click', () => { closeMega(false); });
  }

  /* ---------- Cart count: the theme and the cart drawer rewrite .thb-item-count; keep the badge and label in step. */
  const cart = root.querySelector('[data-shto-mnav-cart]');
  const count = cart && cart.querySelector('.thb-item-count');
  if (cart && count) {
    const sync = () => {
      const n = count.textContent.trim() || (count.querySelector('svg') ? '99+' : '0');
      if (count.dataset.count !== n) count.dataset.count = n;
      cart.setAttribute('aria-label', `${cart.dataset.label}, ${n} ${cart.dataset.items}`);
    };
    new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
    sync();
  }
})();
